import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { TRANSFORM_BEFORE, TRANSFORM_AFTER } from './salesData';
export function ProblemSolutionSection() {
  return <section id="problema-solucion" className="bg-white py-11 sm:py-14" data-id="element-151" data-mp="2vazxcjhcxnlp">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-152" data-mp="2gm3q2on4kem5">
        <h2 className="mx-auto max-w-[20ch] text-center font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2rem]" data-id="element-153" data-mp="2lilrpfn5rwu9">
          No te faltan tutoriales.{' '}
          <span className="text-gold-deep" data-id="element-154" data-mp="3e6py63dk0dy0">Te falta un sistema.</span>
        </h2>

        <div className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-155" data-mp="3091bcpzxewqb">
          <div className="rounded-2xl bg-cream p-4 sm:p-5" data-id="element-156" data-mp="30am5wfm8qfo6">
            <p className="font-display text-[0.62rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-157" data-mp="348jvhjjxb3s3">
              Probando a ciegas
            </p>
            <ul className="mt-3 space-y-2" data-id="element-158" data-mp="1sug5spkdc1su">
              {TRANSFORM_BEFORE.map(item => <li key={item} className="flex gap-2 font-sans text-[0.83rem] leading-snug text-taupe" data-id="element-159" data-mp="yj29yiz5rdkj">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-taupe/50" aria-hidden strokeWidth={3} data-id="element-160" data-mp="tk8zkzf642ol" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-gold bg-gold-soft p-4 sm:p-5" data-id="element-161" data-mp="13iexl5xusoo6">
            <p className="font-display text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-162" data-mp="1hhy7a36bc82l">
              Con las 200 fórmulas
            </p>
            <ul className="mt-3 space-y-2" data-id="element-163" data-mp="1cibrpn30ifqm">
              {TRANSFORM_AFTER.map(item => <li key={item} className="flex gap-2 font-sans text-[0.83rem] font-semibold leading-snug text-charcoal" data-id="element-164" data-mp="1r6g5ccn7k12j">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-165" data-mp="207o1op65yrtz" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}